function calculaValor(
  valor,
  aliquotaPadrao,
  usaAliquotaDiferenciada,
  aplicacaoAliquota,
  aliquotasDiferenciadas
) {
  return !usaAliquotaDiferenciada
    ? calcularValorPorAliquota(valor, aliquotaPadrao)
    : TipoAplicacaoAliquotaDiferenciadaItbi.FAIXA === aplicacaoAliquota
    ? calculaValorPorFaixa(valor, aliquotasDiferenciadas)
    : calculaValorPorIntervalo(valor, aliquotasDiferenciadas);
}

function calculaValorPorFaixa(valor, aliquotas) {
  aliquotas.sort((a1, a2) => a1.valorFinal - a2.valorFinal);
  for (const aliquota of aliquotas) {
    if (rangeDeValorContain(aliquota)(valor)) {
      return calcularValorPorAliquota(valor, aliquota.aliquota);
    }
  }
  return mountAliquotaAplicada((0).toFixed(2), 0);
}

function calcularValorPorAliquota(valorBase, aliquota) {
  const coeficiente = (aliquota / 100).toFixed(6);
  const valor = +(valorBase * coeficiente).toFixed(2);
  return mountAliquotaAplicada(valor, aliquota);
}

function calculaValorPorIntervalo(valor, aliquotas) {
  aliquotas.sort((a1, a2) => a1.valorFinal - a2.valorFinal);
  let valorCalculado = 0;
  let result = 0;
  let index = 0;
  let maxIndex = aliquotas.length - 1;
  let valorRestante = valor * -1 * -1;
  while (valorCalculado < valor) {
    if (index > maxIndex) {
      result = 0;
      break;
    }

    const aliquota = aliquotas[index];
    if (rangeDeValorContain(aliquota)(valorCalculado + valorRestante)) {
      const response = calcularValorPorAliquota(
        valorRestante,
        aliquota.aliquota
      );
      result += +response.valor;
      break;
    }
    const valorParaCalcular = +aliquota.valorFinal - +valorCalculado;
    const response = calcularValorPorAliquota(valorRestante, aliquota.aliquota);
    result += +response.valor;
    valorRestante -= +valorParaCalcular;
    valorCalculado += +valorParaCalcular;
    index++;
  }
  return mountAliquotaAplicada(result.toFixed(2), 0);
}

function rangeDeValorContain(aliquota) {
  return valor =>
    aliquota.valorInicial <= valor && valor <= aliquota.valorFinal;
}

function mountAliquotaAplicada(valor, aliquota) {
  return { valor, aliquota };
}

function mountResponse(valorTransacaoItbi, valorFinanciadoItbi) {
  return { valorTransacaoItbi, valorFinanciadoItbi };
}

function calculaValorNormalBase(valor, parametroItbi, aliquotaDefault) {
  const usaAliquotaDiferenciada =
    parametroItbi.utilizaAliquotaDiferenciadaTipoNormal;
  const tipoAplicacao = parametroItbi.tipoAliquotaDiferenciadaNormal;
  const aliquotas = parametroItbi.aliquotasNormal;
  const aliquotaPadrao = aliquotaDefault ?? parametroItbi.aliquotaNormal;

  return calculaValor(
    valor,
    aliquotaPadrao,
    usaAliquotaDiferenciada,
    tipoAplicacao,
    aliquotas
  );
}

function calculaValorFinanciadoAVistaBase(
  valor,
  parametroItbi,
  aliquotaDefault
) {
  const usaAliquotaDiferenciada =
    parametroItbi.utilizaAliquotaDiferenciadaTipoFinanciadoAVista;
  const tipoAplicacao = parametroItbi.tipoAliquotaDiferenciadaFinanciadoAVista;
  const aliquotas = parametroItbi.aliquotasFinanciadoAVista;
  const aliquotaPadrao =
    aliquotaDefault ?? parametroItbi.aliquotaFinanciadoAVista;
  return calculaValor(
    valor,
    aliquotaPadrao,
    usaAliquotaDiferenciada,
    tipoAplicacao,
    aliquotas
  );
}

function calculaValorFinanciadoBase(
  valorTotal,
  baseCalculo,
  parametroItbi,
  aliquotaDefault
) {
  const {
    utilizaAliquotaDiferenciadaTipoFinanciado: usaAliquotaDiferenciada,
    tipoAliquotaDiferenciadaFinanciado: tipoAplicacao,
    aliquotasFinanciado: aliquotas,
    aliquotaFinanciado: aliquotaFinanciadoPadrao,
    usaAliquotaGeralFinanciado,
    aliquotaGeralValorFinanciado,
    aliquotaGeralAliquotaFinanciado
  } = parametroItbi;

  const aliquotaPadrao = aliquotaDefault ?? aliquotaFinanciadoPadrao;

  if (!usaAliquotaDiferenciada) {
    return calculaValor(baseCalculo, aliquotaPadrao, false);
  }

  if (
    usaAliquotaGeralFinanciado &&
    valorTotal >= aliquotaGeralValorFinanciado
  ) {
    return calculaValor(baseCalculo, aliquotaGeralAliquotaFinanciado, false);
  }

  return calculaValor(
    baseCalculo,
    aliquotaPadrao,
    true,
    tipoAplicacao,
    aliquotas
  );
}

function calculaValorAnuenciaBase(valor, parametroItbi, aliquotaDefault) {
  return calculaValor(
    valor,
    aliquotaDefault ?? parametroItbi.aliquotaAnuencia,
    false
  );
}

export const TipoAplicacaoAliquotaDiferenciadaItbi = {
  FAIXA: 'FAIXA',
  INTERVALO: 'INTERVALO'
};

const CalculoDeclaracaoitbiUtils = {
  calculaValorNormal: calculaValorNormalBase,
  calculaValorFinanciadoAVista: calculaValorFinanciadoAVistaBase,
  calculaValorFinanciado: calculaValorFinanciadoBase,
  calculaValorAnuencia: calculaValorAnuenciaBase,
  calculaValores: declaracaoItbi => {
    const {
      tipoItbi,
      valorTransacaoAvaliacao,
      valorFinanciadoAvaliacao,
      aliquotaTransacao,
      aliquotaFinanciado
    } = declaracaoItbi;
    const { parametroItbi } = tipoItbi;

    let valorTransacao = 0;
    let valorFinanciado = 0;

    if (tipoItbi.normal || tipoItbi.partilha || tipoItbi.isencao) {
      valorTransacao = calculaValorNormalBase(
        valorTransacaoAvaliacao,
        parametroItbi,
        aliquotaTransacao
      );
    } else if (tipoItbi.anuencia) {
      valorTransacao = calculaValorAnuenciaBase(
        valorTransacaoAvaliacao,
        parametroItbi,
        aliquotaTransacao
      );
      valorFinanciado = calculaValorAnuenciaBase(
        valorFinanciadoAvaliacao,
        parametroItbi,
        aliquotaFinanciado
      );
    } else if (tipoItbi.financiado) {
      valorTransacao = calculaValorFinanciadoAVistaBase(
        valorTransacaoAvaliacao,
        parametroItbi,
        aliquotaTransacao
      );
      valorFinanciado = calculaValorFinanciadoBase(
        valorTransacaoAvaliacao + valorFinanciadoAvaliacao,
        valorFinanciadoAvaliacao,
        parametroItbi,
        aliquotaFinanciado
      );
    }
    return mountResponse(valorTransacao, valorFinanciado);
  }
};

export default CalculoDeclaracaoitbiUtils;
